class LoadMore extends HTMLElement {
    connectedCallback() {
      this.productListContainer = document.querySelector('#product-grid');
      this.addEventListener('click', this.onHandler.bind(this));
    }
    onHandler(e) {
      e.preventDefault();

      const link = e.target.closest('a');
      const url = link.href;

      fetch(url)
      .then(res => res.text())
      .then( data => {
        const html = new DOMParser().parseFromString(data, 'text/html');

        const products = html.querySelector('#product-grid').innerHTML;
        const loadMore = html.querySelector('load-more').innerHTML;

        this.productListContainer.insertAdjacentHTML('beforeend', products);
        this.innerHTML = loadMore;
      });
    }
  }
  customElements.define('load-more', LoadMore);